import React from "react";
import { ListItem } from "./ListItem";
import { PowerSupplyContext } from "../../..";
import { useTranslation } from "react-i18next";
import AlertIcon from "@learningblocks/exp-constants/lib/Images/hint_icon_attention.svg";

import "./style.scss";

const TRANSLATION_KEY = {
  TITLE: "Hint.string",
  CONTENT: "HintContent.string",
};

/**
 * HintBlock:
 *    render hint in instruction block
 */
export function HintBlock() {
  const {
    t,
    //i18n
  } = useTranslation();

  const TITLE = t(TRANSLATION_KEY.TITLE);
  const DESCRIPTION = t(TRANSLATION_KEY.CONTENT);

  const { powerSupplyPluggedIn } = React.useContext(PowerSupplyContext); //substitute value when transfix is set
  const { gelBoxPluggedIn } = React.useContext(PowerSupplyContext);

  return (
    <div className="ps_hintBlock">
      <img
        className="ps_hintBlock_title_icon"
        src={AlertIcon}
        alt="Alert icon"
      />
      <span className="ps_hintBlock_title">{TITLE}</span>
      <span className="ps_hintBlock_text">{DESCRIPTION}</span>
      <ListItem type={"Powersupply"} isSuccess={powerSupplyPluggedIn} />
      <ListItem type={"Gelbox"} isSuccess={gelBoxPluggedIn} />
    </div>
  );
}

HintBlock.propTypes = {};

HintBlock.defaultProps = {};
